var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.readonly ? _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_vm.value.isInbound ? _c('invoice-party-form', {
    ref: "sellerForm",
    attrs: {
      "partnerId": _vm.value.partnerId,
      "readonly": true,
      "title": _vm.$t('objects.invoice.seller')
    },
    model: {
      value: _vm.value.seller,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "seller", $$v);
      },
      expression: "value.seller"
    }
  }) : _vm._e(), !_vm.value.isInbound ? _c('invoice-party-form', {
    ref: "buyerForm",
    attrs: {
      "partnerId": _vm.value.partnerId,
      "readonly": _vm.readonly,
      "title": _vm.$t('objects.invoice.buyer')
    },
    model: {
      value: _vm.value.buyer,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "buyer", $$v);
      },
      expression: "value.buyer"
    }
  }) : _vm._e()], 1)], 1) : _c('v-row', [_c('v-col', [!_vm.value.buyer ? _c('company-selection', {
    model: {
      value: _vm.buyerCompany,
      callback: function callback($$v) {
        _vm.buyerCompany = $$v;
      },
      expression: "buyerCompany"
    }
  }) : _c('invoice-party-form', {
    ref: "buyerForm",
    attrs: {
      "partnerId": _vm.value.partnerId,
      "readonly": _vm.readonly,
      "isCompanySelect": true,
      "title": _vm.$t('objects.invoice.buyer')
    },
    on: {
      "remove": function remove($event) {
        _vm.buyerCompany = null;
        _vm.value.buyer = undefined;
      }
    },
    model: {
      value: _vm.value.buyer,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "buyer", $$v);
      },
      expression: "value.buyer"
    }
  }), _vm.buyerCompany ? _c('debug', [_vm._v(" " + _vm._s(_vm.buyerCompany.billingProfile) + " ")]) : _vm._e()], 1)], 1), _c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.invoice.number'),
      "hide-details": "",
      "persistent-hint": "",
      "readonly": _vm.value.direction === _vm.DocumentDirectionEnum.OUTBOUND ? true : _vm.readonly,
      "rules": _vm.value.direction === _vm.DocumentDirectionEnum.OUTBOUND ? undefined : _vm.rules(_vm.RulesEnum.REQUIRED_RULE)
    },
    model: {
      value: _vm.value.number,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "number", $$v);
      },
      expression: "value.number"
    }
  })], 1), _c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "4",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.invoice.servicePeriod'),
      "hide-details": "",
      "persistent-hint": "",
      "readonly": _vm.readonly,
      "type": "date",
      "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE)
    },
    model: {
      value: _vm.value.servicePeriodStart,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "servicePeriodStart", $$v);
      },
      expression: "value.servicePeriodStart"
    }
  })], 1), _c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "4",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.invoice.date'),
      "hide-details": "",
      "persistent-hint": "",
      "readonly": _vm.readonly,
      "type": "date",
      "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE)
    },
    model: {
      value: _vm.value.dateFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "dateFormable", $$v);
      },
      expression: "value.dateFormable"
    }
  })], 1), _c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "4",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.invoice.due'),
      "hide-details": "",
      "persistent-hint": "",
      "readonly": _vm.readonly,
      "type": "date",
      "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE)
    },
    model: {
      value: _vm.value.dueFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "dueFormable", $$v);
      },
      expression: "value.dueFormable"
    }
  })], 1)], 1), _c('v-row', [_c('v-col', [_c('v-select', {
    staticClass: "text-h6",
    attrs: {
      "items": _vm.invoiceTypes,
      "readonly": _vm.readonly,
      "hide-details": "",
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('span', [_vm._v(" " + _vm._s(_vm.$t("enums.InvoiceTypeEnum.".concat(item))))])];
      }
    }, {
      key: "selection",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('span', [_vm._v(" " + _vm._s(_vm.$t("enums.InvoiceTypeEnum.".concat(item))))])];
      }
    }]),
    model: {
      value: _vm.value.type,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "type", $$v);
      },
      expression: "value.type"
    }
  }), _c('v-textarea', {
    staticClass: "pt-1 mr-n2",
    attrs: {
      "label": _vm.$t('objects.invoice.header'),
      "dense": "",
      "hide-details": "",
      "persistent-hint": "",
      "readonly": _vm.readonly,
      "outlined": "",
      "rows": "2"
    },
    model: {
      value: _vm.value.header,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "header", $$v);
      },
      expression: "value.header"
    }
  })], 1)], 1), _c('v-row', [_c('v-col', [_c('div', {
    staticClass: "d-flex justify-space-between align-center px-3"
  }, [_c('h4', {
    staticClass: "text-subtitle-1 mb-2"
  }, [_vm._v(_vm._s(_vm.$t("objects.invoice.notes")))]), !_vm.readonly ? _c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.addNoteEntry('');
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" " + _vm._s(_vm.$t("invoice.addNote")) + " ")], 1) : _vm._e()], 1), _vm.value.notes && _vm.value.notes.length ? _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l(_vm.value.notes, function (entry, index) {
    return _c('v-list-item', {
      key: 'note-' + index,
      staticClass: "my-n4",
      attrs: {
        "dense": ""
      }
    }, [_c('v-list-item-content', {
      staticClass: "pa-0"
    }, [_c('v-text-field', {
      attrs: {
        "placeholder": _vm.$t('objects.invoice.note'),
        "readonly": _vm.readonly,
        "dense": "",
        "hide-details": ""
      },
      model: {
        value: _vm.value.notes[index],
        callback: function callback($$v) {
          _vm.$set(_vm.value.notes, index, $$v);
        },
        expression: "value.notes[index]"
      }
    })], 1), !_vm.readonly ? _c('v-list-item-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "x-small": ""
      },
      on: {
        "click": function click($event) {
          return _vm.removeNoteEntry(index);
        }
      }
    }, [_c('v-icon', [_vm._v("mdi-delete")])], 1)], 1) : _vm._e()], 1);
  }), 1) : _vm._e()], 1)], 1), _c('v-row', {
    staticClass: "d-none d-sm-flex"
  }, [_c('v-col', [_c('v-simple-table', {
    attrs: {
      "dense": ""
    }
  }, [[_c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _c('th', [_vm._v(_vm._s(_vm.$t("objects.invoiceLine.title")))]), _c('th', {
    staticClass: "text-end"
  }, [_vm._v(_vm._s(_vm.$t("objects.invoiceLine.amount")))]), _c('th', {
    staticClass: "text-end"
  }, [_vm._v(_vm._s(_vm.$t("objects.invoiceLine.quantity")))]), _c('th', {
    staticClass: "text-end"
  }, [_vm._v(_vm._s(_vm.$t("objects.invoiceLine.taxRate")))]), _c('th', {
    staticClass: "text-end"
  }, [_vm._v(_vm._s(_vm.$t("objects.invoiceLine.total")))])])]), _c('tbody', [_vm._l(_vm.value.lineItems, function (item, index) {
    return [_c('invoice-form-lines-table-row', {
      key: index + 'tr1',
      attrs: {
        "value": item,
        "currency": _vm.value.currency,
        "index": index,
        "readonly": _vm.readonly,
        "coverageType": _vm.coverageType
      }
    }), _c('tr', {
      key: index + 'tr2'
    }, [_c('td', {
      staticStyle: {
        "border-top": "none"
      }
    }), _c('td', {
      staticStyle: {
        "border-top": "none"
      },
      attrs: {
        "colspan": "5"
      }
    }, [_c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('v-textarea', {
      attrs: {
        "placeholder": _vm.$t('objects.invoiceLine.description'),
        "dense": "",
        "hide-details": "",
        "readonly": _vm.readonly,
        "rows": "1"
      },
      model: {
        value: item.description,
        callback: function callback($$v) {
          _vm.$set(item, "description", $$v);
        },
        expression: "item.description"
      }
    }), _c('tooltip', {
      attrs: {
        "text": _vm.$t('remove')
      }
    }, [!_vm.readonly && _vm.value.lineItems.length > 1 ? _c('v-btn', {
      staticClass: "pa-4 mr-n3",
      attrs: {
        "icon": "",
        "x-small": ""
      },
      on: {
        "click": function click($event) {
          return _vm.removeInvoiceLine(index);
        }
      }
    }, [_c('v-icon', [_vm._v("mdi-delete")])], 1) : _vm._e()], 1)], 1)])])];
  }), !_vm.readonly ? _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "none"
    },
    attrs: {
      "colspan": "6"
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "color": "primary"
    },
    on: {
      "click": _vm.addInvoiceLine
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" " + _vm._s(_vm.$t("invoice.addPosition")) + " ")], 1)], 1)]) : _vm._e(), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "none"
    },
    attrs: {
      "colspan": "4"
    }
  }), _c('td', {
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("objects.invoice.subTotal")) + " ")]), _c('td', {
    staticClass: "text-end",
    attrs: {
      "colspan": "1"
    }
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.value.totalNet, _vm.value.currency)) + " ")])])]), _vm._l(_vm.taxRates, function (taxRate) {
    return _c('tr', {
      key: 'taxRate' + taxRate
    }, [_c('td', {
      staticStyle: {
        "border-bottom": "none"
      },
      attrs: {
        "colspan": "4"
      }
    }), _c('td', {
      staticStyle: {
        "min-width": "150px"
      },
      attrs: {
        "colspan": "1"
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.$t("objects.invoiceLine.taxTotal")) + " " + _vm._s(taxRate) + " "), _c('span', [_vm._v("%")])])]), _c('td', {
      staticClass: "text-end",
      attrs: {
        "colspan": "1"
      }
    }, [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.value.calcItemsPerTaxRate(taxRate), _vm.value.currency)) + " ")])]);
  }), _c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "none"
    },
    attrs: {
      "colspan": "4"
    }
  }), _c('td', {
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("objects.invoice.total")) + " ")]), _c('td', {
    staticClass: "text-end",
    attrs: {
      "colspan": "1"
    }
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.value.totalGross, _vm.value.currency)) + " ")])])])], 2)]], 2)], 1)], 1), _c('v-row', {
    staticClass: "d-sm-none",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_vm._l(_vm.value.lineItems, function (item, index) {
    return _c('v-list-item', {
      key: 'item' + index
    }, [_c('v-list-item-subtitle', [_vm._v(_vm._s(item.title))]), _c('v-list-item-title', [_vm._v(" " + _vm._s(item.quantity) + " x " + _vm._s(_vm.formatCurrency(item.amount, _vm.value.currency)) + " ")])], 1);
  }), _c('v-divider'), _c('v-list-item', [_c('v-list-item-subtitle', [_vm._v(" " + _vm._s(_vm.$t("objects.invoice.subTotal")))]), _c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.value.totalNet, _vm.value.currency)) + " ")])], 1), _c('v-divider'), _vm._l(_vm.taxRates, function (taxRate) {
    return _c('v-list-item', {
      key: 'l-taxRate' + taxRate
    }, [_c('v-list-item-subtitle', [_vm._v(" " + _vm._s(_vm.$t("objects.invoiceLine.taxRate")) + " " + _vm._s(taxRate) + " "), _c('span', [_vm._v("%")])]), _c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.value.calcItemsPerTaxRate(taxRate), _vm.value.currency)) + " ")])], 1);
  }), _c('v-divider'), _c('v-list-item', [_c('v-list-item-subtitle', [_vm._v(" " + _vm._s(_vm.$t("objects.invoice.total")))]), _c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.value.totalGross, _vm.value.currency)) + " ")])], 1)], 2)], 1)], 1), _vm.value.isOutbound ? _c('v-row', [_c('v-col', [_vm.value.isUpdateable ? _c('v-textarea', {
    staticClass: "px-2",
    attrs: {
      "label": _vm.$t('objects.invoice.footer'),
      "dense": "",
      "hide-details": "",
      "persistent-hint": "",
      "value": _vm.footerDefault,
      "readonly": true,
      "rows": "4"
    }
  }) : _c('v-textarea', {
    staticClass: "px-2",
    attrs: {
      "label": _vm.$t('objects.invoice.footer'),
      "dense": "",
      "hide-details": "",
      "persistent-hint": "",
      "value": _vm.value.footer,
      "readonly": true,
      "rows": "4"
    }
  })], 1)], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }